import PropTypes from 'prop-types'

import * as S from './styled'

const Client = ({ name = 'user', projectName, picture }) => {
  return (
    <S.Container>
      <S.PhotoContainer>
        <S.PhotoImage avatar={picture}>
          {!picture && name.substring(0, 1)}
        </S.PhotoImage>
      </S.PhotoContainer>

      <div>
        <S.Title size="giga" noMargin>
          {name}
        </S.Title>
        <S.ProjectTitle>{projectName}</S.ProjectTitle>
      </div>
    </S.Container>
  )
}

Client.propTypes = {
  name: PropTypes.string,
  projectName: PropTypes.string,
  profilePicture: PropTypes.string
}

export default Client
